import { EmbedMode, EmbedTheme } from "../../utils/embeds";
import { getItemDisplayTitle } from "authory-api-types/dist/helpers/contentItem";
import { ItemMetadata } from "../V3ProfileListItem";
import { VerticalSpacing } from "../VerticalSpacing";
import { EmbedWrapper, V3EmbedArticleDescription, V3EmbedArticleImage, V3EmbedArticlePreview, V3EmbedArticleTitle } from "./V3EmbedContent.styles";
import { V3EmbedAuthor } from "./V3EmbedAuthor";
import { ArticlePreviewResponse, ContentResponse, UserResponse } from "authory-api-types/dist/types";
import { UnstyledLink } from "../ReusableStyledComponents/UnstyledLink";
import { getItemUrl } from "../V3ProfileList/V3ProfileList.utils";
import { V3EmbedPoweredBy } from "./V3EmbedPoweredBy";

interface V3EmbedContentProps {
    embedTheme?: EmbedTheme;
    embedMode?: EmbedMode;
    author: UserResponse;
    content: ContentResponse;
    showHeader?: boolean;
}

export const V3EmbedContent = ({
    embedTheme = EmbedTheme.light,
    embedMode = EmbedMode.normal,
    author,
    content,
    showHeader = true
}: V3EmbedContentProps) => {
    const contentTargetLink = getItemUrl(content as unknown as ArticlePreviewResponse, `${process.env.NEXT_PUBLIC_FRONTEND_URL}/${author.slug}`);

    const hasThumbnailImage = !!content.thumbnailImage;
    const haspreviewImage = !!content.previewImage;

    const headlineUseOneLine = embedMode === EmbedMode.normal || (embedMode === EmbedMode.compact && !hasThumbnailImage);

    return (
        <EmbedWrapper embedTheme={embedTheme}>
            {showHeader && <V3EmbedAuthor author={author} embedTheme={embedTheme} />}
            <UnstyledLink href={author.displayAuthoryPage ? contentTargetLink : undefined} target="_blank">
                <VerticalSpacing bottom={18}>
                    <V3EmbedArticlePreview embedMode={embedMode}>
                        {hasThumbnailImage && haspreviewImage && (
                            <VerticalSpacing bottom={embedMode === EmbedMode.normal ? 18 : 0}>
                                <V3EmbedArticleImage
                                    $embedMode={embedMode}
                                    $imageSrc={embedMode === EmbedMode.normal ? content.previewImage : content.thumbnailImage}
                                />
                            </VerticalSpacing>
                        )}
                        <div>
                            <VerticalSpacing bottom={18}>
                                <V3EmbedArticleTitle $numLines={headlineUseOneLine ? 1 : 2} $embedTheme={embedTheme}>
                                    {getItemDisplayTitle(content)}
                                </V3EmbedArticleTitle>
                            </VerticalSpacing>
                            {!!content.description && (
                                <div>
                                    <V3EmbedArticleDescription $numLines={4} $embedTheme={embedTheme}>
                                        {content.description}
                                    </V3EmbedArticleDescription>
                                </div>
                            )}
                        </div>
                    </V3EmbedArticlePreview>
                </VerticalSpacing>
            </UnstyledLink>
            <VerticalSpacing bottom={12}>
                <UnstyledLink href={author.displayAuthoryPage ? contentTargetLink : undefined} target="_blank">
                    <ItemMetadata item={content} customDateFormat={"MMM dd, yyyy"} showRedirect={false} isEmbed embedTheme={embedTheme} />
                </UnstyledLink>
            </VerticalSpacing>
            <V3EmbedPoweredBy embedTheme={embedTheme} utmCampaign="article" />
        </EmbedWrapper>
    );
};
